import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons/faArrowLeft";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons/faArrowRight";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "react-router";
import { EduIDButton } from "./EduIDButton";
function PreviousLink({ previousLink, previousText, previousOnClick, }) {
    if (previousLink) {
        return (_jsxs(Link, { className: "left", to: previousLink, "aria-label": previousText, children: [_jsx(FontAwesomeIcon, { icon: faArrowLeft }), " ", _jsx("span", { children: previousText })] }));
    }
    if (previousOnClick) {
        return (_jsxs(EduIDButton, { buttonstyle: "link normal-case", className: "left", onClick: previousOnClick, "aria-label": previousText, children: [_jsx(FontAwesomeIcon, { icon: faArrowLeft }), " ", _jsx("span", { children: previousText })] }));
    }
    return null;
}
function NextLink({ nextLink, nextText, nextOnClick, }) {
    if (nextLink) {
        return (_jsxs(Link, { className: "right", to: nextLink, "aria-label": nextText, children: [_jsx("span", { children: nextText }), " ", _jsx(FontAwesomeIcon, { icon: faArrowRight })] }));
    }
    if (nextOnClick) {
        return (_jsxs(EduIDButton, { buttonstyle: "link normal-case", className: "right", onClick: nextOnClick, "aria-label": nextText, children: [_jsx("span", { children: nextText }), " ", _jsx(FontAwesomeIcon, { icon: faArrowRight })] }));
    }
    return null;
}
export function WizardLink({ previousLink, previousText, previousOnClick, nextLink, nextText, nextOnClick, }) {
    return (_jsxs("section", { className: "wizard-link-wrapper", children: [_jsx(PreviousLink, { previousLink: previousLink, previousText: previousText, previousOnClick: previousOnClick }), _jsx(NextLink, { nextLink: nextLink, nextText: nextText, nextOnClick: nextOnClick })] }));
}
